export default class ArrayFunctions {
    static countOccurrences(arr) {
        let a = []; let b = []; let prev;

        arr.sort();
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] !== prev) {
                a.push(arr[i]);
                b.push(1);
            } else {
                b[b.length - 1]++;
            }
            prev = arr[i];
        }

        return [a, b];
    }
    static unique(array) {
        return array.filter((value, index) => array.indexOf(value) === index);
    }
}
